import _ from 'lodash';
import getRouteConstants from 'app/selectors/route';
import { getUser } from 'app/selectors/user';
import { promiseError } from 'app/common/actions/common';
import {
  fetchUser,
  fetchFeatures,
  fetchGlobalFooter,
  fetchDefaultMetadata,
} from 'app/common/api/common-api';

import {
  getGlobalFooterContent,
  getDefaultMetadata,
} from 'app/common/selectors/common';

import { subscriptions } from 'app/selectors/subscriptions';

// Basic Props and Dispatches for all root apps
export const baseMapStateToProps = (state, ownProps) => {
  const user = getUser(state);
  const isRestricted = subscriptions.getIsRestricted(state);
  const routeConstants = getRouteConstants(null, ownProps.route);
  return ({
    user,
    isRestricted,
    pageTitle: routeConstants.PAGE_TITLE,
    hideNavLinks: routeConstants.HIDE_NAV_LINKS,
    hideUserSection: routeConstants.HIDE_USER_SECTION,
    useMarketingNav: routeConstants.USE_MARKETING_NAV,
    includeBuyButton: routeConstants.INCLUDE_BUY_BUTTON,
    showFooter: routeConstants.SHOW_GLOBAL_FOOTER,
    canonicalUri: routeConstants.CANONICAL_URI,
    preloadError: _.get(state, 'common.preloadError'),
    noticeLevelError: _.get(state, 'common.noticeLevelError'),
    defaultMetadata: getDefaultMetadata(state),
    ...getGlobalFooterContent(state),
  });
};

export const baseMapDispatchToProps = dispatch => ({
  clearGlobalError: () => dispatch(promiseError(null)),
});

// Same as baseMapDispatchToProps, but adds clientPreloads for use with ./client-preload
export const baseNoAuthMapDispatchToProps = dispatch => ({
  clientPreloads: [
    () => dispatch(fetchUser()),
  ],
  ...baseMapDispatchToProps(dispatch),
});

export const basePreload = (dispatch, state) => ([
  dispatch(fetchUser()),
  dispatch(fetchFeatures(_.get(state, 'common.ip'))),
  dispatch(fetchGlobalFooter()),
  dispatch(fetchDefaultMetadata()),
]);

// Defer user to front end
export const baseNoAuthPreload = (dispatch, state) => ([
  dispatch(fetchFeatures(_.get(state, 'common.ip'))),
  dispatch(fetchGlobalFooter()),
  dispatch(fetchDefaultMetadata()),
]);



// WEBPACK FOOTER //
// ./app/common/containers/base.js